import React from "react";

const DiamondOutlined = (props) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M23.0787 9.13326L17.6412 2.33772C17.625 2.31779 17.6046 2.30169 17.5814 2.29058C17.5583 2.27946 17.5329 2.27361 17.5072 2.27344H6.49295C6.44206 2.27344 6.39117 2.29754 6.35903 2.33772L0.921525 9.13326C0.89635 9.16512 0.883105 9.20479 0.884084 9.24539C0.885062 9.28599 0.900201 9.32497 0.926882 9.35558L11.8715 21.6636C11.9037 21.7011 11.9519 21.7199 12.0001 21.7199C12.0483 21.7199 12.0938 21.6984 12.1287 21.6636L23.0733 9.35558C23.1 9.32497 23.1151 9.28599 23.1161 9.24539C23.1171 9.20479 23.1038 9.16512 23.0787 9.13326ZM15.568 3.81094L16.4894 7.39754L12.9403 3.81094H15.568ZM15.7876 8.59219H8.2126L12.0001 4.76451L15.7876 8.59219ZM8.43224 3.81094H11.0599L7.50813 7.39754L8.43224 3.81094ZM7.00188 3.99844L5.82063 8.59219H3.32688L7.00188 3.99844ZM3.49831 9.93147H6.02688L9.39652 16.5663L3.49831 9.93147ZM12.0001 18.7306L7.52956 9.93147H16.468L12.0001 18.7306ZM14.601 16.5663L17.9733 9.93147H20.5019L14.601 16.5663ZM18.1796 8.59219L16.9983 3.99844L20.6733 8.59219H18.1796Z"
				fill="currentColor"
				fill-opacity="0.85"
			/>
		</svg>
	);
};

export default DiamondOutlined;

